import gsap from 'gsap'

export function scrollTop (scroller) {
  if (scroller) {
    scroller.scrollTo(0, 0, 0)
  } else {
    gsap.to(window, { scrollTo: 0 })
  }
}

export function scrollToInner (factor, scroller, duration = 0) {
  if (scroller) {
    scroller.scrollTo(0, factor * window.innerHeight, duration)
  } else {
    gsap.to(window, { scrollTo: factor * window.innerHeight })
  }
}

export function scrollTo (element, scroller, duration = 0) {
  const offset = element.offsetTop
  if (scroller) {
    scroller.scrollTo(0, offset, duration)
  } else {
    gsap.to(window, { scrollTo: offset })
  }
}
